<template>
    <div class="layout-dialog relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-2 sm:items-center sm:p-0">
                <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                    <div>
                        <h3 class="text-lg font-semibold leading-6 text-gray-900" id="modal-title" :class="!!$slots.content ? 'mb-5' : ''" v-if="title">
                            {{ title }}
                        </h3>
                        <div v-if="!!$slots.content">
                            <slot name="content"></slot>
                        </div>
                    </div>
                    <div class="mt-5 flex flex-row sm:mt-6" v-if="!!$slots.buttons">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LayoutDialog',
    props: {
        title: {
            required: false,
            type: String,
            default: null,
        },
    },
};
</script>
